type BrandLogoProps = {
  variant?: 'mark' | 'full';
  className?: string;
  alt?: string;
};

export function BrandLogo({
  variant = 'mark',
  className = '',
  alt = 'Perspectify',
}: BrandLogoProps) {
  const src =
    variant === 'full'
      ? '/brand/perspectify-logo.svg'
      : '/brand/perspectify-mark.svg';

  return <img src={src} alt={alt} className={className} />;
}
